const categoryGroups = [
  {
    name: 'Home Services',
    categoryOptions: [
      { value: 149, label: 'Appliance Installation & Repair' },
      { value: 249, label: 'Bathroom Remodeling' },
      { value: 168, label: 'Carpet & Flooring' },
      { value: 152, label: 'Carpet Cleaning & Repair' },
      { value: 5000, label: 'Electricians' },
      { value: 6000, label: 'Exterminators (Pest Control)' },
      { value: 167, label: 'Garage Doors' },
      { value: 189, label: 'Handyman Services' },
      { value: 308, label: 'Hardwood Floor Installers & Refinishers' },
      { value: 846, label: 'Home Security' },
      { value: 825, label: 'Home Warranty Plans' },
      { value: 186, label: 'House Cleaners' },
      { value: 17, label: 'HVAC Contractors' },
      { value: 250, label: 'Kitchen Remodeling' },
      { value: 20, label: 'Landscapers' },
      { value: 814, label: 'Lawn Care & Maintenance' },
      { value: 173, label: 'Locksmiths' },
      { value: 175, label: 'Mold Remediation' },
      { value: 24, label: 'Painters' },
      { value: 10000, label: 'Plumbers' },
      { value: 11000, label: 'Roofers' },
      { value: 162, label: 'Self Storage' },
      { value: 177, label: 'Siding Contractors' },
      { value: 483, label: 'Solar Installers' },
      { value: 403, label: 'Trash Containers & Dumpsters' },
      { value: 164, label: 'Tree Services' },
      { value: 354, label: 'Water & Fire Damage Restoration' },
      { value: 12000, label: 'Waterproofers' },
      { value: 160, label: 'Window Installers' }
    ]
  },
  {
    name: 'Legal',
    categoryOptions: [
      { value: 8003, label: 'Bankruptcy Lawyers' },
      { value: 8031, label: 'Car Accident Lawyers' },
      { value: 8008, label: 'Criminal Lawyers' },
      { value: 8011, label: 'Divorce Lawyers' },
      { value: 8012, label: 'DUI Lawyers' },
      { value: 8015, label: 'Employment Lawyers' },
      { value: 8032, label: 'Family Lawyers' },
      { value: 8033, label: 'Foreclosure Lawyers' },
      { value: 8000, label: 'General Legal Calls' },
      { value: 8018, label: 'Immigration Lawyers' },
      { value: 8026, label: 'IRS Tax Debt Lawyers' },
      { value: 8035, label: 'Medical Malpractice Lawyers' },
      { value: 8030, label: 'Mesothelioma Lawyers' },
      { value: 8001, label: 'Personal Injury Lawyers' },
      { value: 8025, label: 'Social Security Lawyers' },
      { value: 8027, label: 'Traffic Lawyers' },
      { value: 8009, label: 'Workers Compensation Lawyers' }
    ]
  },
  {
    name: 'Mass Torts',
    categoryOptions: [
      { value: 849, label: 'Mass Tort Lawyers - Hernia Mesh' },
      { value: 850, label: 'Mass Tort Lawyers - Invokana' },
      { value: 851, label: 'Mass Tort Lawyers - IVC Filter' },
      { value: 852, label: 'Mass Tort Lawyers - Lung Cancer' },
      { value: 853, label: 'Mass Tort Lawyers - Metal-On-Metal Hip' },
      { value: 854, label: 'Mass Tort Lawyers - Proton Pump Inhibitors' },
      { value: 855, label: 'Mass Tort Lawyers - Talcum Powder' },
      { value: 856, label: 'Mass Tort Lawyers - Taxotere' },
      { value: 857, label: 'Mass Tort Lawyers - Xarelto' },
      { value: 858, label: 'Mass Tort Lawyers - Zostavax' }
    ]
  },
  {
    name: 'Debt',
    categoryOptions: [
      { value: 778, label: 'Credit Repair' },
      { value: 845, label: 'Debt Consolidation' },
      { value: 859, label: 'Debt Relief' },
      { value: 860, label: 'Student Debt' }
    ]
  },
  {
    name: 'Drug Addiction & Rehab',
    categoryOptions: [{ value: 183, label: 'Addiction Treatment' }]
  },
  {
    name: 'Movers',
    categoryOptions: [
      { value: 9000, label: 'Movers - Local' },
      { value: 861, label: 'Movers - Long Distance' }
    ]
  },
  {
    name: 'Automotive',
    categoryOptions: [
      { value: 517, label: 'Auto Glass' },
      { value: 3, label: 'Auto Repair & Service' },
      { value: 862, label: 'Auto Warranty Plans' },
      { value: 863, label: 'Donate Your Car' },
      { value: 401, label: 'Towing Service' }
    ]
  },
  {
    name: 'Insurance',
    categoryOptions: [
      { value: 7002, label: 'Auto Insurance' },
      { value: 7004, label: 'Business Insurance' },
      { value: 864, label: 'Final Expense Insurance' },
      { value: 7006, label: 'Health Insurance' },
      { value: 7007, label: 'Homeowners Insurance' },
      { value: 7008, label: 'Life Insurance' },
      { value: 7009, label: 'Long Term Care Insurance' },
      { value: 865, label: 'Medicare Supplemental Insurance' },
      { value: 7012, label: 'Workers Compensation & Disability Insurance' }
    ]
  },
  {
    name: 'Mortgages/Finance',
    categoryOptions: [
      { value: 866, label: 'Auto Leasing & Finance' },
      { value: 867, label: 'Credit Cards' },
      { value: 868, label: 'Loans - Business' },
      { value: 869, label: 'Loans - Payday Loans' },
      { value: 870, label: 'Loans - Personal' },
      { value: 871, label: 'Merchant Cash Advance' },
      { value: 651, label: 'Mortgages' },
      { value: 872, label: 'Mortgages - Refinance' },
      { value: 873, label: 'Mortgages - Reverse' }
    ]
  },
  {
    name: 'Senior Products & Services',
    categoryOptions: [
      { value: 54, label: 'Assisted Living' },
      { value: 775, label: 'Hearing Aids' },
      { value: 57, label: 'Home Care & Nurses' },
      { value: 874, label: 'Medical Alerts Systems' },
      { value: 875, label: 'Stair Lifts' },
      { value: 836, label: 'Walk-in Tubs' }
    ]
  },
  {
    name: 'Medical',
    categoryOptions: [
      { value: 1000, label: 'Chiropractors' },
      { value: 3000, label: 'Dentists' },
      { value: 4004, label: 'Pain Management' },
      { value: 244, label: 'Hair Restoration & Treatment' },
      { value: 58, label: 'Physical Therapists' },
      { value: 4026, label: 'Plastic Surgeons' },
      { value: 74, label: 'Veterinarians' }
    ]
  },
  {
    name: 'Travel',
    categoryOptions: [
      { value: 876, label: 'Cruises' },
      { value: 877, label: 'Discount Airfare' },
      { value: 878, label: 'Timeshares' }
    ]
  },
  {
    name: 'Other Verticals',
    categoryOptions: [
      { value: 339, label: 'Adoption Services' },
      { value: 88, label: 'Bail Bonds' },
      { value: 362, label: 'Cemeteries & Cremation Services' },
      { value: 248, label: 'Computer & Software Repair' },
      { value: 628, label: 'Dating & Relationships' },
      { value: 89, label: 'Driving Schools & Instructors' },
      { value: 313, label: 'Education & Instruction' },
      { value: 194, label: 'Florists' },
      { value: 91, label: 'Funeral Homes & Directors' },
      { value: 847, label: 'Internet & Cable' },
      { value: 880, label: 'Mobile Carriers' },
      { value: 96, label: 'Real Estate Agents' },
      { value: 881, label: 'Satellite TV Service' }
    ]
  }
];

export const sortedCategoryOptions = categoryGroups
  .map((group) => group.categoryOptions)
  .reduce((acc, item) => [...acc, ...item], [])
  .sort((a, b) => {
    const nameA = a.label.toUpperCase();
    const nameB = b.label.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });

export default categoryGroups;
